import {createReducer, updateObject} from './reducerUtilities';
import { SHOW_SNACKBAR_REQUEST, HIDE_SNACKBAR_REQUEST} from '../actions/actionTypes';

const initialState = {
   snackbar: {
      snackbarVisible: false,
      snackbarMsg: ''
   }
 };

 // Slice reducer
export const snackbarReducer = createReducer(initialState, {
   [SHOW_SNACKBAR_REQUEST] : showSnackbarRequest,
   [HIDE_SNACKBAR_REQUEST] : hideSnackbarRequest,

});


// Case reducer
function showSnackbarRequest(state, action) {
   return {...state, snackbar: updateObject(
       state.snackbar, { 
           snackbarVisible: true,
           snackbarMsg: action.data
       })};
}

function hideSnackbarRequest(state, action) {
   return {...state, snackbar: updateObject(
       state.snackbar, { 
           snackbarVisible: false,
           snackbarMsg: ''
       })};
}


// WEBPACK FOOTER //
// ./src/reducers/snackbarReducer.js